import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function FacturationPage() {
  const navigate = useNavigate();
  const { utilisateur } = useAuth();
  const [abattoirs, setAbattoirs] = useState([]);
  const [tarifs, setTarifs] = useState({});
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);
  const [productionChargee, setProductionChargee] = useState(false);

  const [form, setForm] = useState({
    abattoir_id: utilisateur?.abattoir_id || '',
    date_facturation: new Date().toISOString().split('T')[0],
    session_label: 'PRINCIPALE',
    type_jour: 'STANDARD',
    bovins_nbr: 0, bovins_poids: 0, bovins_stab_nuit: 0,
    ovins_nbr: 0, ovins_poids: 0,
    caprins_nbr: 0, caprins_poids: 0,
    porcins_nbr: 0, porcins_poids: 0,
    vf_poids: 0, vf_tarif: 0,
    stockage_frigo: 0, stockage_abattoir: 0,
    location: 0, timbres: 0, tickets: 0,
    bon_sortie_numero: '', bon_sortie_nombre: 0,
    observations: ''
  });

  useEffect(() => {
    api.get('/abattoirs').then(r => setAbattoirs(r.data));
  }, []);

  useEffect(() => {
    if (form.abattoir_id) {
      api.get(`/facturation/tarifs/${form.abattoir_id}`).then(r => {
        setTarifs(r.data);
        const tarifVF = r.data['tarif_vf_global'] || 0;
        setForm(f => ({ ...f, vf_tarif: tarifVF }));
      });
    }
  }, [form.abattoir_id]);

  const chargerProduction = async () => {
    if (!form.abattoir_id || !form.date_facturation) return;
    try {
      const r = await api.get(`/facturation/production/${form.abattoir_id}/${form.date_facturation}`);
      if (r.data) {
        setForm(f => ({
          ...f,
          bovins_nbr: Math.round(r.data.bovins_nbr) || 0,
          bovins_poids: parseFloat(r.data.bovins_poids) || 0,
          ovins_nbr: Math.round(r.data.ovins_nbr) || 0,
          ovins_poids: parseFloat(r.data.ovins_poids) || 0,
          caprins_nbr: Math.round(r.data.caprins_nbr) || 0,
          caprins_poids: parseFloat(r.data.caprins_poids) || 0,
          porcins_nbr: Math.round(r.data.porcins_nbr) || 0,
          porcins_poids: parseFloat(r.data.porcins_poids) || 0,
          vf_poids: parseFloat(r.data.vf_poids_total) || 0,
        }));
        setProductionChargee(true);
        setMessage({ type: 'succes', texte: '✅ Données de production chargées !' });
      } else {
        setMessage({ type: 'info', texte: '⚠️ Aucune production trouvée pour cette date.' });
      }
    } catch (e) {
      setMessage({ type: 'erreur', texte: 'Erreur chargement production.' });
    }
  };

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const t = (espece) => tarifs[`${espece}_${form.type_jour}`] || {};

  const calc = {
    bovins_stab_jour: (form.bovins_nbr||0) * (t('bovin').tarif_stabulation||0),
    bovins_abattage:  (form.bovins_poids||0) * (t('bovin').tarif_abattage||0),
    bovins_ressuage:  t('bovin').ressuage_unite === 'tete'
      ? (form.bovins_nbr||0)   * (t('bovin').tarif_ressuage||0)
      : (form.bovins_poids||0) * (t('bovin').tarif_ressuage||0),
    ovins_stab:       (form.ovins_nbr||0) * (t('ovin').tarif_stabulation||0),
    ovins_abattage:   (form.ovins_poids||0) * (t('ovin').tarif_abattage||0),
    caprins_stab:     (form.caprins_nbr||0) * (t('caprin').tarif_stabulation||0),
    caprins_abattage: (form.caprins_poids||0) * (t('caprin').tarif_abattage||0),
    porcins_stab:     (form.porcins_nbr||0) * (t('porcin').tarif_stabulation||0),
    porcins_abattage: (form.porcins_poids||0) * (t('porcin').tarif_abattage||0),
  };

  const calc_vf_montant = (parseFloat(form.vf_poids)||0) * (parseFloat(form.vf_tarif)||0);
  const bovins_stab_total = calc.bovins_stab_jour + parseFloat(form.bovins_stab_nuit||0);
  const totalBovins = bovins_stab_total + calc.bovins_abattage + calc.bovins_ressuage;
  const totalOvins = calc.ovins_stab + calc.ovins_abattage;
  const totalCaprins = calc.caprins_stab + calc.caprins_abattage;
  const totalPorcins = calc.porcins_stab + calc.porcins_abattage;
  const totalAbattoir = totalBovins + totalOvins + totalCaprins + totalPorcins;
  const totalAnnexes = parseFloat(form.stockage_frigo||0) + parseFloat(form.stockage_abattoir||0) +
    parseFloat(form.location||0) + parseFloat(form.timbres||0) + parseFloat(form.tickets||0);
  const totalGeneral = totalAbattoir + calc_vf_montant + totalAnnexes;

  const totalStab = bovins_stab_total + calc.ovins_stab + calc.caprins_stab + calc.porcins_stab;
  const totalAbat = calc.bovins_abattage + calc.ovins_abattage + calc.caprins_abattage + calc.porcins_abattage;
  const totalResu = calc.bovins_ressuage;

  const fmt = (n) => Math.round(n).toLocaleString('fr-FR');

  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true);
    try {
      await api.post('/facturation', { ...form, ...calc, vf_montant: calc_vf_montant });
      setMessage({ type: 'succes', texte: '✅ Facturation enregistrée !' });
      setTimeout(() => navigate('/facturation/liste'), 2000);
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur.' });
    } finally { setChargement(false); }
  };

  const C = {
    primary: '#2E7D32', primaryDark: '#1B5E20',
    border: '#E0E0E0', light: '#F4F6F9',
    green50: '#F1F8F2', green100: '#E8F5E9',
  };

  const S = {
    page: { minHeight: '100vh', background: C.light },
    topbar: { height: 52, background: '#fff', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 28px', position: 'sticky', top: 0, zIndex: 100 },
    breadcrumb: { fontSize: 13, color: '#9E9E9E', display: 'flex', alignItems: 'center', gap: 6 },
    breadcrumbActive: { color: '#212121', fontWeight: 600 },
    container: { maxWidth: 1000, margin: '24px auto', padding: '0 20px' },
    titre: { color: C.primary, fontSize: 20, fontWeight: 700, marginBottom: 20 },
    carte: { background: 'white', borderRadius: 12, marginBottom: 20, border: `1px solid ${C.border}`, overflow: 'hidden' },
    titreCarte: () => ({ background: C.primary, color: '#fff', padding: '10px 16px', fontSize: 13, fontWeight: 700, borderRadius: '0' }),
    titreCarteColored: (c) => ({ background: c, color: '#fff', padding: '10px 16px', fontSize: 13, fontWeight: 700 }),
    carteBody: { padding: '20px 24px' },
    grille4: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 12 },
    grille3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 },
    grille2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15 },
    label: { display: 'block', fontSize: 12, color: '#616161', marginBottom: 4, fontWeight: 600 },
    input: { width: '100%', padding: '9px 12px', border: `1.5px solid ${C.border}`, borderRadius: 8, fontSize: 14, boxSizing: 'border-box', outline: 'none' },
    inputLecture: { width: '100%', padding: '9px 12px', border: `1.5px solid #A5D6A7`, borderRadius: 8, fontSize: 14, background: C.green50, fontWeight: 700, color: C.primaryDark, boxSizing: 'border-box' },
    inputNuit: { width: '100%', padding: '9px 12px', border: '1.5px solid #FFCC80', borderRadius: 8, fontSize: 14, background: '#FFFDE7', boxSizing: 'border-box' },
    totalLigne: { display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: C.green50, borderRadius: 6, marginTop: 12, fontWeight: 700, color: C.primaryDark },
    totalGeneral: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: C.green100, border: `1.5px solid #A5D6A7`, borderRadius: 8, fontSize: 16, fontWeight: 700, color: C.primaryDark, marginTop: 15 },
    badge: (tj) => ({ display: 'inline-block', padding: '3px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700, background: tj==='SPECIAL'?'#FFF8E1':'#E8F5E9', color: tj==='SPECIAL'?'#E65100':C.primary, marginLeft: 10, border: `1px solid ${tj==='SPECIAL'?'#FFE082':'#A5D6A7'}` }),
    alerte: (tp) => ({ padding: '12px 16px', borderRadius: 8, marginBottom: 15, background: tp==='succes'?C.green100:tp==='info'?'#E3F2FD':'#FFEBEE', color: tp==='succes'?C.primaryDark:tp==='info'?'#1565C0':'#C62828', border: `1px solid ${tp==='succes'?'#A5D6A7':tp==='info'?'#90CAF9':'#EF9A9A'}`, fontSize: 14 }),
    btnPrimary: { background: C.primary, color: 'white', border: 'none', padding: '12px 24px', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer' },
    btnSecondary: { background: 'white', color: C.primary, border: `1.5px solid ${C.primary}`, padding: '9px 18px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' },
    btnRetour: { background: 'transparent', border: 'none', color: '#757575', fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 },
    tarif: { fontSize: 11, color: '#9E9E9E', marginTop: 3 },
    th: (c) => ({ background: c, color: 'white', padding: '10px 12px', textAlign: 'right', fontSize: 12, fontWeight: 600 }),
    thL: (c) => ({ background: c, color: 'white', padding: '10px 12px', textAlign: 'left', fontSize: 12, fontWeight: 600 }),
    td: { padding: '9px 12px', textAlign: 'right', borderBottom: `1px solid ${C.border}`, fontSize: 13 },
    tdL: { padding: '9px 12px', textAlign: 'left', borderBottom: `1px solid ${C.border}`, fontWeight: 600, fontSize: 13 },
  };

  const lignesTableau = [
    { label:'🐄 Bovins', bg:'#fff9f5', stab: bovins_stab_total, abat: calc.bovins_abattage, resu: calc.bovins_ressuage, vf: 0 },
    { label:'🐑 Ovins',  bg:'#f5f9ff', stab: calc.ovins_stab,   abat: calc.ovins_abattage,   resu: 0, vf: 0 },
    { label:'🐐 Caprins',bg:'#f5fff8', stab: calc.caprins_stab, abat: calc.caprins_abattage, resu: 0, vf: 0 },
    { label:'🐖 Porcins',bg:'#fdf5ff', stab: calc.porcins_stab, abat: calc.porcins_abattage, resu: 0, vf: 0 },
    { label:'🥩 V.Foraine',bg:'#fff5f5',stab: 0, abat: 0, resu: 0, vf: calc_vf_montant },
  ];

  return (
    <div style={S.page}>
      <div style={S.topbar}>
        <div style={S.breadcrumb}>
          <span>Facturation</span>
          <span>›</span>
          <span style={S.breadcrumbActive}>Nouvelle facturation</span>
          <span style={S.badge(form.type_jour)}>{form.type_jour}</span>
        </div>
        <button style={S.btnRetour} onClick={() => navigate('/facturation/liste')}>← Retour à la liste</button>
      </div>
      <div style={S.container}>
        <div style={S.titre}>🧾 Facturation journalière</div>
        {message.texte && <div style={S.alerte(message.type)}>{message.texte}</div>}

        <form onSubmit={soumettre}>
          {/* EN-TÊTE */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>📋 Informations générales</div>
            <div style={S.carteBody}><div style={S.grille4}>
              <div>
                <label style={S.label}>Abattoir</label>
                <select style={S.input} name="abattoir_id" value={form.abattoir_id} onChange={champ} required disabled={utilisateur?.role==='prepose'}>
                  <option value="">-- Choisir --</option>
                  {abattoirs.map(a => <option key={a.id} value={a.id}>{a.nom}</option>)}
                </select>
              </div>
              <div>
                <label style={S.label}>Date</label>
                <input style={S.input} type="date" name="date_facturation" value={form.date_facturation} onChange={champ} required />
              </div>
              <div>
                <label style={S.label}>Type de jour</label>
                <select style={S.input} name="type_jour" value={form.type_jour} onChange={champ}>
                  <option value="STANDARD">STANDARD (tarif normal)</option>
                  <option value="SPECIAL">SPECIAL (tarif majoré)</option>
                </select>
              </div>
              <div>
                <label style={S.label}>Session</label>
                <select style={S.input} name="session_label" value={form.session_label} onChange={champ}>
                  <option value="PRINCIPALE">Principale</option>
                  <option value="MATIN">Matin</option>
                  <option value="SOIR">Soir</option>
                  <option value="SPECIALE">Spéciale (événement)</option>
                </select>
              </div>
            </div>
            <div style={{ marginTop: 15 }}>
              <button type="button" style={S.btnSecondary} onClick={chargerProduction}>
                🔄 Charger données production Module 1
              </button>
              {productionChargee && <span style={{ marginLeft: 10, color: C.primary, fontSize: 13 }}>✅ Production chargée</span>}
            </div>
            </div>
          </div>

          {/* BOVINS */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>🐄 BOVINS — {form.type_jour}: Stab {t('bovin').tarif_stabulation} F/tête | Abattage {t('bovin').tarif_abattage} F/kg | Ressuage {t('bovin').tarif_ressuage} F/kg</div>
            <div style={S.carteBody}><div style={S.grille4}>
              <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="bovins_nbr" value={form.bovins_nbr} onChange={champ} /></div>
              <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="bovins_poids" value={form.bovins_poids} onChange={champ} /></div>
              <div>
                <label style={S.label}>Stabulation nuit (FCFA)</label>
                <input style={S.inputNuit} type="number" min="0" name="bovins_stab_nuit" value={form.bovins_stab_nuit} onChange={champ} />
                <div style={S.tarif}>Saisie manuelle</div>
              </div>
              <div>
                <label style={S.label}>Stabulation jour (auto)</label>
                <input style={S.inputLecture} value={fmt(calc.bovins_stab_jour)} readOnly />
                <div style={S.tarif}>{form.bovins_nbr} × {t('bovin').tarif_stabulation} F</div>
              </div>
              <div>
                <label style={S.label}>Abattage (auto)</label>
                <input style={S.inputLecture} value={fmt(calc.bovins_abattage)} readOnly />
                <div style={S.tarif}>{form.bovins_poids} kg × {t('bovin').tarif_abattage} F</div>
              </div>
              <div>
                <label style={S.label}>Ressuage (auto)</label>
                <input style={S.inputLecture} value={fmt(calc.bovins_ressuage)} readOnly />
                <div style={S.tarif}>{form.bovins_poids} kg × {t('bovin').tarif_ressuage} F</div>
              </div>
            </div>
            <div style={S.totalLigne}><span>TOTAL BOVINS</span><span>{fmt(totalBovins)} FCFA</span></div>
            </div>
          </div>

          {/* OVINS */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>🐑 OVINS — {form.type_jour}: Stab {t('ovin').tarif_stabulation} F/tête | Abattage {t('ovin').tarif_abattage} F/kg</div>
            <div style={S.carteBody}><div style={S.grille4}>
              <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="ovins_nbr" value={form.ovins_nbr} onChange={champ} /></div>
              <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="ovins_poids" value={form.ovins_poids} onChange={champ} /></div>
              <div><label style={S.label}>Stabulation (auto)</label><input style={S.inputLecture} value={fmt(calc.ovins_stab)} readOnly /><div style={S.tarif}>{form.ovins_nbr} × {t('ovin').tarif_stabulation} F</div></div>
              <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.ovins_abattage)} readOnly /><div style={S.tarif}>{form.ovins_poids} kg × {t('ovin').tarif_abattage} F</div></div>
            </div>
            <div style={S.totalLigne}><span>TOTAL OVINS</span><span>{fmt(totalOvins)} FCFA</span></div>
            </div>
          </div>

          {/* CAPRINS */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>🐐 CAPRINS — {form.type_jour}: Stab {t('caprin').tarif_stabulation} F/tête | Abattage {t('caprin').tarif_abattage} F/kg</div>
            <div style={S.carteBody}><div style={S.grille4}>
              <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="caprins_nbr" value={form.caprins_nbr} onChange={champ} /></div>
              <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="caprins_poids" value={form.caprins_poids} onChange={champ} /></div>
              <div><label style={S.label}>Stabulation (auto)</label><input style={S.inputLecture} value={fmt(calc.caprins_stab)} readOnly /></div>
              <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.caprins_abattage)} readOnly /></div>
            </div>
            <div style={S.totalLigne}><span>TOTAL CAPRINS</span><span>{fmt(totalCaprins)} FCFA</span></div>
            </div>
          </div>

          {/* PORCINS */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>🐖 PORCINS — {form.type_jour}: Stab {t('porcin').tarif_stabulation} F/tête | Abattage {t('porcin').tarif_abattage} F/kg</div>
            <div style={S.carteBody}><div style={S.grille4}>
              <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="porcins_nbr" value={form.porcins_nbr} onChange={champ} /></div>
              <div><label style={S.label}>Poids total (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="porcins_poids" value={form.porcins_poids} onChange={champ} /></div>
              <div><label style={S.label}>Stabulation (auto)</label><input style={S.inputLecture} value={fmt(calc.porcins_stab)} readOnly /></div>
              <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.porcins_abattage)} readOnly /></div>
            </div>
            <div style={S.totalLigne}><span>TOTAL PORCINS</span><span>{fmt(totalPorcins)} FCFA</span></div>
            </div>
          </div>

          {/* VIANDE FORAINE */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>🥩 Viande Foraine — Tarif unique (indépendant STANDARD/SPECIAL)</div>
            <div style={S.carteBody}><div style={S.grille3}>
              <div>
                <label style={S.label}>Poids viande foraine (kg)</label>
                <input style={S.input} type="number" min="0" step="0.01" name="vf_poids" value={form.vf_poids} onChange={champ} />
                <div style={S.tarif}>Récupéré du Module 1 ou saisie manuelle</div>
              </div>
              <div>
                <label style={S.label}>Tarif (FCFA/kg)</label>
                <input style={S.input} type="number" min="0" step="0.01" name="vf_tarif" value={form.vf_tarif} onChange={champ} />
                <div style={S.tarif}>Modifiable si besoin</div>
              </div>
              <div>
                <label style={S.label}>Montant VF (auto)</label>
                <input style={S.inputLecture} value={fmt(calc_vf_montant)} readOnly />
                <div style={S.tarif}>{form.vf_poids} kg × {form.vf_tarif} F</div>
              </div>
            </div>
            <div style={S.totalLigne}><span>TOTAL VIANDE FORAINE</span><span>{fmt(calc_vf_montant)} FCFA</span></div>
            </div>
          </div>

          {/* PRESTATIONS ANNEXES */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>💰 Prestations annexes (saisie manuelle)</div>
            <div style={S.carteBody}><div style={S.grille4}>
              <div><label style={S.label}>Stockage frigo (FCFA)</label><input style={S.input} type="number" min="0" name="stockage_frigo" value={form.stockage_frigo} onChange={champ} /></div>
              <div><label style={S.label}>Stockage abattoir (FCFA)</label><input style={S.input} type="number" min="0" name="stockage_abattoir" value={form.stockage_abattoir} onChange={champ} /></div>
              <div><label style={S.label}>Location (FCFA)</label><input style={S.input} type="number" min="0" name="location" value={form.location} onChange={champ} /></div>
              <div><label style={S.label}>Timbres (FCFA)</label><input style={S.input} type="number" min="0" name="timbres" value={form.timbres} onChange={champ} /></div>
              <div>
                <label style={S.label}>Tickets vendus (FCFA)</label>
                <input style={S.input} type="number" min="0" name="tickets" value={form.tickets} onChange={champ} />
                <div style={S.tarif}>Montant total tickets d'entrée</div>
              </div>
              <div><label style={S.label}>N° Bon de sortie</label><input style={S.input} type="text" name="bon_sortie_numero" value={form.bon_sortie_numero} onChange={champ} placeholder="Ex: BS-2026-001" /></div>
              <div><label style={S.label}>Nombre bons</label><input style={S.input} type="number" min="0" name="bon_sortie_nombre" value={form.bon_sortie_nombre} onChange={champ} /></div>
            </div>
            </div>
          </div>

          {/* OBSERVATIONS */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>📝 Observations</div>
            <div style={S.carteBody}><textarea style={{ ...S.input, height: 80, resize: 'vertical' }} name="observations" value={form.observations} onChange={champ} placeholder="Remarques éventuelles..." /></div>
          </div>

          {/* RÉCAPITULATIF DÉTAILLÉ */}
          <div style={S.carte}>
            <div style={S.titreCarte()}>📊 Récapitulatif détaillé par type de prestation</div>
            <div style={S.carteBody}><table style={{ width:'100%', borderCollapse:'collapse', fontSize:13, marginBottom:20 }}>
              <thead>
                <tr>
                  <th style={S.thL('#424242')}>Espèce</th>
                  <th style={S.th('#5D4037')}>💰 Stabulation</th>
                  <th style={S.th('#1565C0')}>🔪 Abattage</th>
                  <th style={S.th('#00695C')}>❄️ Ressuage</th>
                  <th style={S.th('#B71C1C')}>🥩 V.Foraine</th>
                  <th style={S.th(C.primaryDark)}>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {lignesTableau.map(row => {
                  const tot = row.stab + row.abat + row.resu + row.vf;
                  return (
                    <tr key={row.label} style={{ background: row.bg }}>
                      <td style={S.tdL}>{row.label}</td>
                      <td style={{ ...S.td, color: row.stab>0?'#5D4037':'#BDBDBD' }}>{row.stab>0 ? fmt(row.stab) : '—'}</td>
                      <td style={{ ...S.td, color: row.abat>0?'#1565C0':'#BDBDBD' }}>{row.abat>0 ? fmt(row.abat) : '—'}</td>
                      <td style={{ ...S.td, color: row.resu>0?'#00695C':'#BDBDBD' }}>{row.resu>0 ? fmt(row.resu) : '—'}</td>
                      <td style={{ ...S.td, color: row.vf>0?'#B71C1C':'#BDBDBD' }}>{row.vf>0 ? fmt(row.vf) : '—'}</td>
                      <td style={{ ...S.td, fontWeight:700, color: tot>0?C.primaryDark:'#BDBDBD' }}>{tot>0 ? fmt(tot) : '—'}</td>
                    </tr>
                  );
                })}
                <tr style={{ background: C.green50, fontWeight:700, borderTop:`2px solid ${C.primary}` }}>
                  <td style={S.tdL}>📊 TOTAUX PAR TYPE</td>
                  <td style={{ ...S.td, color:'#5D4037', fontWeight:700 }}>{fmt(totalStab)}</td>
                  <td style={{ ...S.td, color:'#1565C0', fontWeight:700 }}>{fmt(totalAbat)}</td>
                  <td style={{ ...S.td, color:'#00695C', fontWeight:700 }}>{fmt(totalResu)}</td>
                  <td style={{ ...S.td, color:'#B71C1C', fontWeight:700 }}>{fmt(calc_vf_montant)}</td>
                  <td style={{ ...S.td, color:C.primaryDark, fontSize:14, fontWeight:700 }}>{fmt(totalAbattoir+calc_vf_montant)}</td>
                </tr>
              </tbody>
            </table>

            {/* Prestations annexes */}
            <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:10, marginBottom:15 }}>
              {[
                ['🧊 Stockage frigo', form.stockage_frigo],
                ['🏚️ Stockage abattoir', form.stockage_abattoir],
                ['🏢 Location', form.location],
                ['🎫 Tickets', form.tickets],
                ['📋 Timbres', form.timbres],
              ].map(([label, val]) => {
                const v = parseFloat(val||0);
                return (
                  <div key={label} style={{ textAlign:'center', padding:'10px', background:'#FFFDE7', borderRadius:8, border:`1px solid ${C.border}` }}>
                    <div style={{ fontSize:11, color:'#9E9E9E', marginBottom:4 }}>{label}</div>
                    <div style={{ fontWeight:700, color: v>0?'#E65100':'#BDBDBD', fontSize:13 }}>{v>0 ? fmt(v)+' F' : '—'}</div>
                  </div>
                );
              })}
            </div>

            <div style={S.totalGeneral}>
              <div>
                <div style={{ fontSize:12, color:'#4CAF50', marginBottom:4 }}>
                  Abattoir+VF : {fmt(totalAbattoir+calc_vf_montant)} F &nbsp;|&nbsp; Annexes : {fmt(totalAnnexes)} F
                </div>
                <div>💵 TOTAL GÉNÉRAL</div>
              </div>
              <span style={{ fontSize:22, fontWeight:800 }}>{fmt(totalGeneral)} FCFA</span>
            </div>
            </div>
          </div>

          <button type="submit" style={{ background: C.primary, color: 'white', border: 'none', padding: '14px 24px', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', width: '100%', marginBottom: 30 }} disabled={chargement}>
            {chargement ? '⏳ Enregistrement...' : '💾 ENREGISTRER LA FACTURATION'}
          </button>
        </form>
      </div>
    </div>
  );
}
